<iframe [ngClass]="isDesktop ? 'desktop': 'mobile'" allowfullscreen="true" width="100%" frameborder="0" scrolling="no" [src]="safeUrl"></iframe>